import i18n from '@/i18n';

/**
 * 统一「导出数据」下拉：导出筛选 / 导出本页 / 导出选中。
 * 导出筛选 = 按当前查询条件拉全量；无筛选条件时等同导出全部。
 */

function listText(key) {
  return i18n.t(`tiktokList.${key}`, { ns: 'workbench', defaultValue: key });
}

export const OPS_EXPORT_LABEL = '导出数据';
export const OPS_EXPORT_LABEL_BUSY = '导出中…';

/**
 * @param {{
 *   exporting?: boolean,
 *   filteredCount?: number,
 *   pageCount?: number,
 *   selectedCount?: number,
 *   onExportFiltered?: () => void,
 *   onExportPage?: () => void,
 *   onExportSelected?: () => void,
 *   filteredDisabled?: boolean,
 *   pageDisabled?: boolean,
 *   selectedDisabled?: boolean,
 * }} opts
 */
export function buildOpsExportMenu({
  exporting = false,
  filteredCount,
  pageCount = 0,
  selectedCount = 0,
  onExportFiltered,
  onExportPage,
  onExportSelected,
  filteredDisabled = false,
  pageDisabled = false,
  selectedDisabled = false,
} = {}) {
  const filteredEmpty = filteredCount != null && Number(filteredCount) <= 0 && pageCount <= 0;
  return [
    {
      key: 'export-filtered',
      label: listText('exportFiltered'),
      ...(filteredCount != null ? { count: Number(filteredCount) || 0 } : {}),
      disabled: exporting || filteredDisabled || filteredEmpty || typeof onExportFiltered !== 'function',
      onClick: onExportFiltered,
    },
    {
      key: 'export-page',
      label: listText('exportPage'),
      count: pageCount,
      disabled: exporting || pageDisabled || pageCount <= 0 || typeof onExportPage !== 'function',
      onClick: onExportPage,
    },
    {
      key: 'export-selected',
      label: listText('exportSelected'),
      count: selectedCount,
      disabled: exporting || selectedDisabled || selectedCount <= 0 || typeof onExportSelected !== 'function',
      onClick: onExportSelected,
    },
  ];
}

export function opsExportLabel(exporting = false) {
  return exporting ? listText('exporting') : listText('exportData');
}
